import { Breakpoints } from './globalStyle'

const media = (breakpoints, size, height) =>
	`@media (min-width: ${breakpoints}) {\nfont-size: ${size};\nline-height: ${height};\n};`
const medias = ([sizeMS, heightMS], [sizeLX, heightLX], [sizeXL, heightXL]) =>
	media(Breakpoints.ms, sizeMS, heightMS) +
	media(Breakpoints.lx, sizeLX, heightLX) +
	media(Breakpoints.xl, sizeXL, heightXL)

export const typography = {
	heading: {
		display: {
			family: 'SBSansDisplay',
			size: '24px',
			lineHeight: '30px',
			weight: 600,
			media: medias(['32px', '40px'], ['40px', '48px'], ['48px', '56px']),
		},
		h1: {
			family: 'SBSansDisplay',
			size: '24px',
			lineHeight: '30px',
			weight: 600,
			media: medias(['28px', '36px'], ['32px', '40px'], ['40px', '48px']),
		},
		h2: {
			family: 'SBSansDisplay',
			size: '24px',
			lineHeight: '30px',
			weight: 600,
			media: medias(['24px', '30px'], ['28px', '36px'], ['32px', '40px']),
		},
		h3Constant: {
			family: 'SBSansDisplay',
			size: '24px',
			lineHeight: '30px',
			weight: 600,
		},
		h3Special: {
			family: 'SBSansDisplay',
			size: '20px',
			lineHeight: '32px',
			weight: 600,
			media: medias(['20px', '32px'], ['24px', '36px'], ['24px', '36px']),
		},
		h3: {
			family: 'SBSansDisplay',
			size: '18px',
			lineHeight: '26px',
			weight: 600,
			media: medias(['18px', '26px'], ['20px', '28px'], ['24px', '30px']),
		},
		h4: {
			family: 'SBSansDisplay',
			size: '18px',
			lineHeight: '26px',
			weight: 600,
			media: medias(['18px', '26px'], ['20px', '28px'], ['20px', '28px']),
		},
	},
	text: {
		body: {
			family: 'SBSansInterface',
			size: '18px',
			lineHeight: '28px',
			weight: 400,
			media: medias(['18px', '28px'], ['18px', '28px'], ['20px', '32px']),
		},
		xl: {
			family: 'SBSansInterface',
			size: '18px',
			lineHeight: '26px',
			media: medias(['18px', '26px'], ['18px', '26px'], ['20px', '28px']),
		},
		l: {
			family: 'SBSansInterface',
			size: '16px',
			lineHeight: '24px',
		},
		m: {
			family: 'SBSansInterface',
			size: '14px',
			lineHeight: '20px',
		},
		s: {
			family: 'SBSansInterface',
			size: '12px',
			lineHeight: '16px',
		},
	},
	notAdaptive: {
		h1: {
			family: 'SBSansDisplay',
			size: '24px',
			lineHeight: '30px',
			weight: 600,
		},
		h2: {
			family: 'SBSansDisplay',
			size: '20px',
			lineHeight: '28px',
			weight: 600,
		},
		h3: {
			family: 'SBSansDisplay',
			size: '18px',
			lineHeight: '24px',
			weight: 600,
		},
		xl: {
			family: 'SBSansInterface',
			size: '20px',
			lineHeight: '28px',
		},
		l: {
			family: 'SBSansInterface',
			size: '18px',
			lineHeight: '24px',
		},
		m: {
			family: 'SBSansInterface',
			size: '16px',
			lineHeight: '24px',
		},
		s: {
			family: 'SBSansInterface',
			size: '14px',
			lineHeight: '20px',
		},
		xs: {
			family: 'SBSansInterface',
			size: '12px',
			lineHeight: '16px',
			weight: 400,
		},
	},
}
